/**
 * Component: Product Nav
 */
import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class SecureNav {
    constructor() {
        // selectors
        this.selectors = {
            nav: '.secure-nav',
            page: '[data-secure-hero]'

        };

        // elements
        this.$nav = $(this.selectors.nav);
        this.$page = $(this.selectors.page);
        if (!this.$nav && !this.$page) return;
        this.initStickyNav();
    }


    initStickyNav() {
        console.log('testing');
        const pageScrollAnim = (scrollingDown) => {
            console.log(scrollingDown);
            if (scrollingDown === 1) {
                gsap.to(this.$nav, {
                    y: 0
                });
            }
            if (scrollingDown === 0) {
                gsap.to(this.$nav, {
                    y: '-100%'
                });
            }
        };

        const pageTrigger = () => {
            // Get bottom position of product overview
            const triggerBottom = 300;
            console.log(triggerBottom);
            // Keeps track of scroll direction
            ScrollTrigger.create({
                trigger: $('body'),
                // Animation starts as soon as product overview is out of view
                start: triggerBottom,
                toggleActions: 'play none restart reset',
                // We only have access to the direction within the trigger element's height.
                onUpdate: ({ direction }) => pageScrollAnim(direction)
            });
        };

        gsap.to(this.$nav, {
            scrollTrigger: {
                trigger: this.$page,
                start: 'bottom',
                toggleActions: 'play none restart reset',
                onEnter: () => pageTrigger(),
                onUpdate: self => pageScrollAnim(self.progress)
            }
        });
    }
}
